import { ApolloClient } from 'apollo-client';
import gql from 'graphql-tag';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ERROR_LINK } from 'utils/redirects';

const TAXI_GRAPHQL_PASSPORT_ROOT = '/api/v1/passport';

const client = new ApolloClient({
  link: ERROR_LINK.concat(createHttpLink({ uri: TAXI_GRAPHQL_PASSPORT_ROOT })),
  cache: new InMemoryCache(),
});

export function fetchFieldData(salesforceOrg) {
  const query = gql(`{
    fieldMappings(filters: [
      {field: "typeName" value: "lead"},
      {field: "organizationCode" value: "${salesforceOrg}"}
    ]) {
      fieldName
      apiField {
        name
        picklistValues
        type
      }
    } }`);

  return client
    .query({ query })
    .then((response) => response.data.fieldMappings.reduce((map, fieldMappingObject) => {
      map[fieldMappingObject.fieldName] = { // eslint-disable-line no-param-reassign
        apiFieldName: fieldMappingObject.apiField.name,
        sfPicklistValues: JSON.parse(fieldMappingObject.apiField.picklistValues),
        sfFieldType: fieldMappingObject.apiField.type,
      };
      return map;
    }, {}));
}
